import { SVGProps, Ref, forwardRef } from 'react';

export const MapFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.733.899c-1.515.843-3.037 1.678-4.516 2.582C3.541 4.507 1.864 5.686.951 7.483.098 9.163 0 11.11 0 13.316v10.746c0 1.156.03 2.226.178 3.096.127.753.444 2.077 1.641 2.87 1.282.85 2.664.516 3.415.258.828-.286 1.75-.785 2.697-1.34l1.802-1.122zm2.4 26.308c2.58 1.446 5.163 2.883 7.734 4.343V4.8c-2.569-1.44-5.16-2.883-7.734-4.344zM22.267 4.189v26.912c1.537-.864 3.077-1.723 4.59-2.63 1.652-1.011 3.291-2.177 4.192-3.949.853-1.68.951-3.626.951-5.833V7.944c0-1.124-.03-2.16-.163-3.008-.116-.737-.395-1.976-1.436-2.8-1.204-.952-2.577-.737-3.375-.5-.821.244-1.709.707-2.584 1.208z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MapFilledSize32Glyph.displayName = 'MapFilledSize32Glyph';
